<div class="h-[56px] md:h-[64px] bg-[#FCFCF5] fixed top-0 w-full z-[98] md:hidden"></div>
@if (showHeader) {
  <div
    id="header"
    class="h-[56px] md:h-[64px] border-[0.5px] flex items-center md:justify-between px-4 lg:px-[60px] fixed top-4 w-[calc(100%-1rem)] md:w-[calc(100%-128px)] left-1/2 -translate-x-1/2 z-[99] bg-white border-border-background rounded-lg"
    style="box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.05)"
  >
    <a routerLink="/">
      <img src="/assets/logo.svg" alt="Logo" width="80" />
    </a>

    <div class="hidden md:flex items-center mr-auto">
      <button mat-button [matMenuTriggerFor]="productMenu" class="nav-button ml-10 lg:ml-[60px]">
        {{ getButtonLabel('Header Product Button') | async }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>

      <a mat-button href="https://brands.goodchart.co/plans" target="_blank" class="nav-button ml-1 lg:ml-3">
        {{ getButtonLabel('Header Pricing Button') | async }}
      </a>

      <button
        mat-button
        [matMenuTriggerFor]="partnerMenu"
        #partnerTrigger="matMenuTrigger"
        class="nav-button ml-1 lg:ml-3"
      >
        {{ getButtonLabel('Header Resource Button') | async }}
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    </div>

    <a mat-flat-button href="https://apps.shopify.com/goodchart" target="_blank" class="signup-btn ml-auto">
      {{ getButtonLabel('Header Signup Button') | async }}
    </a>

    <app-mobile-menu />
  </div>
}

<mat-menu #partnerMenu="matMenu" class="!min-w-0 !max-w-[unset] [&>.mat-mdc-menu-content]:p-0">
  <!-- eslint-disable-next-line -->
  <div class="flex h-[341px] w-[400px] lg:w-[872px] flex-col lg:flex-row" (click)="$event.stopPropagation()">
    <div class="flex-1 p-8 pb-0">
      <h2 class="font-semibold text-sm border-b border-[#8f8f8f] pb-2 mb-4 leading-[20px]">
        {{ 'component.landing.learn' | translate }}
      </h2>
      <p class="font-semibold text-xs text-[#555549]">{{ 'component.landing.learn-more' | translate }}</p>
      <div class="flex-col w-full grid grid-cols-2 gap-4 mt-4">
        <a [href]="blogPath" class="flex flex-col" target="_blank">
          <p class="font-semibold text-base mb-0.5">{{ 'component.landing.blog' | translate }}</p>
          <p class="font-medium text-sm text-text-6 w-4/5">
            {{ 'component.landing.blog-description' | translate }}
          </p>
        </a>
        <a [routerLink]="helpPath" class="flex flex-col" (click)="closePartnerMenu()">
          <p class="font-semibold text-base mb-0.5">{{ 'component.landing.help-center' | translate }}</p>
          <p class="font-medium text-sm text-text-6 w-4/5">
            {{ 'component.landing.help-center-description' | translate }}
          </p>
        </a>
        <a [href]="demoPath" class="flex flex-col" target="_blank">
          <p class="font-semibold text-base mb-0.5">{{ 'component.landing.demo' | translate }}</p>
          <p class="font-medium text-sm text-text-6 w-4/5">{{ 'component.landing.demo-description' | translate }}</p>
        </a>
      </div>
    </div>
    <div class="lg:w-[306px] bg-surface px-6 py-8 flex flex-col space-y-4">
      <h2 class="font-semibold text-sm border-b border-[#8f8f8f] pb-2">
        {{ 'component.landing.services' | translate }}
      </h2>
      <a class="font-semibold text-base text-text-5 block hover:underline cursor-pointer" [routerLink]="contactPath" (click)="closePartnerMenu()">
        {{ 'component.landing.contact' | translate }}
      </a>
      <a [href]="privacyRoute" class="font-semibold text-base text-text-5 block hover:underline" target="_blank">
        {{ 'component.landing.privacy' | translate }}
      </a>
    </div>
  </div>
</mat-menu>

<mat-menu #productMenu="matMenu">
  <a
    mat-menu-item
    href="https://goodsize.co"
    class="[&>.mat-mdc-menu-item-text]:flex [&>.mat-mdc-menu-item-text]:flex-col"
    target="_blank"
  >
    <p class="font-semibold text-base mb-0.5">{{ 'component.landing.goodsize' | translate }}</p>
    <p class="font-medium text-sm text-text-6">{{ 'component.landing.goodsize-description' | translate }}</p>
  </a>
  <a
    mat-menu-item
    href="https://goodchart.co"
    class="[&>.mat-mdc-menu-item-text]:flex [&>.mat-mdc-menu-item-text]:flex-col"
    target="_blank"
  >
    <p class="font-semibold text-base mb-0.5">{{ 'component.landing.goodchart' | translate }}</p>
    <p class="font-medium text-sm text-text-6">{{ 'component.landing.goodchart-description' | translate }}</p>
  </a>
</mat-menu>
